import React, {useState, useEffect} from "react";
import { useParams } from 'react-router-dom';
import { Form, Input, Button, message, Switch } from 'antd';
import { useHistory } from "react-router-dom";
import tds_mail from "../services/tds_mail.service";

const layout = {
  labelCol: { span: 8 },
  wrapperCol: { span: 16 },
};
const tailLayout = {
  wrapperCol: { offset: 8, span: 16 },
};

export default function TdsMailForm(props) {
  const { id } = useParams();
  const [title, set_title] = useState();
  const [mode, set_mode] = useState();
  const [form] = Form.useForm();
  const history = useHistory();

  // onFinish -------------------------------------------------------
  const onFinish = (values) => {
    tds_mail
      .save(values)
      .then(record => {
        console.log(record);
        message.success('Enregistrement effectué');
        history.push('/tds_mail_list');
      })
      .catch(error => {
        message.error('Une erreur est survenue');
      })
  }

  // load_data ------------------------------------------------------
  const load_data = async () => {
    let r = await tds_mail.load({id: id});
    for (let i in r.data.roles) {
      r.data.roles[i] = r.data.roles[i].id;
    }
    form.setFieldsValue(r.data);
  }

  // useEffect ------------------------------------------------------
  useEffect(() => {
    if (id) {
      set_mode('mod');
      load_data();
    } else {
      set_mode('add');
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])  

  useEffect(() => {
    if (mode === 'add') {
      set_title('Nouveau destinataire TDS');
    } else {
      set_title('Destinataire TDS #' + id);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [mode])  
  
  // render ---------------------------------------------------------
  return (
    <div className="private_page_wrapper">

      <div className="header">
        <span className="title">{title}</span>
      </div>

      <Form 
        {...layout} 
        form={form}
        name="tds_mail_form"
        className="common_form"
        onFinish={onFinish}
      >
        <Form.Item 
          name="id" 
          label="ID"
          hidden={true}
        >
          <Input disabled={true} />
        </Form.Item>

        <Form.Item 
          name="firstname" 
          label="Prénom"
          // rules={[{required: true}]}
        >
          <Input />
        </Form.Item>

        <Form.Item 
          name="lastname" 
          label="Nom"
          // rules={[{required: true}]}
        >
          <Input />
        </Form.Item>

        <Form.Item 
          name="email" 
          label="email"
          rules={[{required: true}]}
        >
          <Input />
        </Form.Item>

        <Form.Item 
          name="active" 
          label="Active"
          valuePropName="checked"
        >
          <Switch checkedChildren="Enable" unCheckedChildren="Disable" defaultChecked />        
        </Form.Item>
        <Form.Item {...tailLayout} className="form_toolbar">
          <Button type="primary" htmlType="submit" onClick={() => history.push("/tds_mail")}>
            Retour
          </Button>
          <Button type="primary" htmlType="submit">
            Enregistrer
          </Button>
        </Form.Item>
      </Form>
    </div>
  )

}